<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-step block-fullscreen-text">
      <h1 class="title-section">Processos</h1>
      <div class="title-main">
        <p>Passar pela Transformação Digital signifca ter todos os setores da empresa alinhados e colaborando entre si. Para operações digitais serem bem-sucedida, é preciso que a organização opere em conjunto, com metas bem definidas e o digital no foco.</p>
        <p>Agora, vamos ver se a sua empresa está seguindo este caminho?</p>
      </div>
      <router-link :to="nextScreen" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import rollDown from './mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'process',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/processos/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 3);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Process.vue